import { createContext, useContext, type ReactNode } from 'react'
import type { BlogPost } from './types/blog'

export type PreloadedData =
  | { kind: 'blog-index' | 'newsroom-index'; posts: BlogPost[] }
  | { kind: 'blog-post' | 'newsroom-post'; slug: string; post: BlogPost | null; posts: BlogPost[] }

const PreloadedDataContext = createContext<PreloadedData | null>(null)

export function PreloadedDataProvider({
  children,
  value,
}: {
  children: ReactNode
  value: PreloadedData | null
}) {
  return (
    <PreloadedDataContext.Provider value={value}>
      {children}
    </PreloadedDataContext.Provider>
  )
}

export function usePreloadedData() {
  return useContext(PreloadedDataContext)
}
